export const Dimensions = {
    maxUIWidth: 1280,
    mobileUIWidth: 1000,
    navBarHeight: 80,
    padding: 15
};
